module.exports = __webpack_public_path__ + "static/credit-card-user-f2b4af44f74645a55718abbd76607808.jpg";